export const LANG_MODE = "ja";

export const LANG = {
  TXT_EMAIL: "メールアドレス",
  TXT_MAIL: "メール",
  TXT_PASSWORD: "パスワード",
  TXT_PASSWORD_CHECK: "パスワード（確認用に再入力）",
  TXT_PASSWORD_RESET: "パスワード再設定",
  TXT_NEW: "新しい",
  TXT_NAME: "名前",
  TXT_EX: "例",
  TXT_NAME_OF: "の名前",
  TXT_CREATED: "登録日",
  TXT_SUBSCRIPTION_DATE: "有料開始日",
  TXT_AUTHORITY: "権限",
  TXT_TIMELINE: "タイムライン",
  TXT_SETTING: "設定",
  TXT_ACCOUNT: "アカウント",
  TXT_PROJECT: "プロジェクト",
  TXT_CODE: "識別コード",
  TXT_ORGANIZATION: "組織",
  TXT_TRACKING: "トラッキング",
  TXT_TRACKING_TEST: "トラッキングテスト",
  TXT_ANALYZE: "解析",
  TXT_LOGOUT: "ログアウト",
  TXT_IMG: "画像",
  TXT_FEATURE_IMG: "注目した画像",
  TXT_PAGE_MAIN_IMG: "ページメイン画像",
  TXT_EVENT: "イベント",
  TXT_ACTION: "行動履歴",
  TXT_KARTE: "カルテ",
  TXT_ADD: "作成",
  TXT_S_ADD: "の作成",
  TXT_S_PLUS: "の追加",
  TXT_SAVE: "保存",
  TXT_SEND: "送信",
  TXT_RESET: "再設定",
  TXT_DISPLAY: "表示",
  TXT_PLUS: "追加",
  TXT_BACK: "戻る",
  TXT_PERIOD: "期間",
  TXT_YMD_FORMAT: "年/月/日",
  TXT_HM_FORMAT: "時:分",
  TXT_LOADMORE: "さらに表示する",
  TXT_DELETE: "削除",
  TXT_CANCEL: "キャンセル",
  TXT_CANCELED: "キャンセル済み",
  TXT_SIGNIN: "サインイン",
  TXT_USER: "ユーザー",
  TXT_IP: "IPアドレス",
  TXT_MEMO: "メモ",
  TXT_UNKNOWN: "不明",
  TXT_CVINFO: "検知したパラメータ",
  TXT_CVINFO_KEY: "パラメータのキー",
  TXT_PGEVENT: "検知したイベント",
  TXT_PINSID: "ピンのID",
  TXT_PINSLABEL: "ラベル",
  TXT_PINSPV: "ピン到達直近のPV",
  TXT_SCROLL_PER: "スクロール",
  TXT_PAGE_TIME: "滞在時間",
  TXT_LAST_ACCESS: "最終アクセス",
  TXT_TITLE: "タイトル",
  TXT_DESCRIPTION: "概要",
  TXT_GENERAL: "一般",
  TXT_INVOICE: "ご請求先",
  TXT_COMPANY_NAME: "会社名",
  TXT_MANAGER: "担当者",
  TXT_LASTNAME: "姓",
  TXT_FIRSTNAME: "名",
  TXT_PHONE: "電話番号",
  TXT_ZIP: "郵便番号",
  TXT_PREF: "都道府県",
  TXT_ADDR01: "市区町村番地",
  TXT_ADDR02: "建物名・部屋番号",
  TXT_TARGET_DOMAIN: "利用先ドメイン",
  TXT_TARGET_DOMAIN_OPTION: "追加オプションのドメイン",
  TXT_PLAN: "ご利用プラン",
  TXT_PAYMENT: "支払い方法",
  TXT_TRACKING_TAG: "トラッキングタグ",
  TXT_ACC_BLOCK: "計測停止",
  TXT_ON_BLOCK: "停止中",
  TXT_TARGET_PAGE: "計測対象ページ",
  TXT_TARGET_PAGE_URL: "対象ページのURL",
  TXT_BLOCK_PAGE_URL: "除外ページのURL",
  TXT_PIN: "ピン",
  TXT_TRACKING_TAG_BASE: "計測タグ",
  TXT_TRACKING_TAG_PARAM: "パラメータタグ",
  TXT_URL_PART: "URLの一致",
  TXT_MATCH_TYPE: "一致条件",
  TXT_EVENT_NAME: "イベント名",
  TXT_EVENT_TYPE: "イベントの形式",
  TXT_EVENT_TARGET: "対象の要素",
  TXT_ATTRIBUTE_NAME: "属性の値",
  TXT_ATTRIBUTE_TYPE: "属性",
  TXT_ITEM: "項目",
  TXT_EVENT_TARGET_PAGE_URL: "対象ページのURL",
  TXT_EVENT_PARAM: "追加設定値",
  TXT_PINN_NAME: "ピンの名前",
  TXT_PINN_CONDITION: "到達条件",
  TXT_CONDITION_AND: "AND",
  TXT_CONDITION_OR: "OR",
  TXT_PINN_CANCEL_SET: "ピン到達の自動キャンセル設定",
  TXT_CANCEL_SET: "キャンセル設定",
  TXT_PINN_CANCEL_PAGE: "キャンセルページのURL",
  TXT_PINN_CANCEL_TARGET_DAY: "キャンセル対象のピン",
  TXT_IGNITION: "の発生",
  TXT_RUN_TEST_MODE: "テストモードの起動",
  TXT_TEST_IP: "接続元IPアドレス",
  TXT_TEST_MODE_LOG: "テストログ",
  TXT_EDIT_LIMIT: "上限の変更",
  TXT_EDIT_PLAN_LIMIT: "プラン上限の変更",
  TXT_START_SUBSCRIPTION: "有料プランにアップグレード",
  TXT_TRIAL_UPGRADE_NOTE_1: "無料トライアルはピン到達数の上限が",
  TXT_TRIAL_UPGRADE_NOTE_2: "までのみ有効です。さらに計測する場合は有料プランにアップグレードしてください。",
  TXT_ADD_LIMIT_OF: "の上限追加",
  TXT_CHANGE_BEFORE_SET: "現在の設定",
  TXT_CHANGE_AFTER_SET: "変更後の設定",
  TXT_REQUEST_LIMIT_ADD: "上限の変更を申し込む",
  TXT_NEXT_MONTH_ONWARD: "翌月以降",
  TXT_UNTIL_THIS_MONTH: "今月まで",
  TXT_SITE_POSITION: "サイトの位置付け",
  TXT_RADER_CHART: "レーダーチャート",
  TXT_ANALYZE_SET: "解析設定",
  TXT_CLUSTER_CATEGORY: "クラスタ種別",
  TXT_CLUSTER: "クラスタ",
  TXT_CLUSTER_NAME: "クラスタ名",
  TXT_CLUSTER_SET: "クラスタ設定",
  TXT_PIN_USER_TREND: "ピン到達ユーザーの傾向",
  TXT_DIVISION_NUM: "データ格納区分",
  TXT_DEVELOPPERS_ACCOUNT: "開発者アカウント",

  TXT_SETTING_LINK: "リンクのURLルールを設定します",
  TXT_LINK_URL_RULE: "リンクのURLルール",
  TXT_SETTING_EXPORT_FORMAT: "エクスポートファイルのフォーマットを設定します",
  TXT_SET_PIN_NOTE: "メモを設定してください",
  TXT_SETTING_NOTE: "このピンにメモを設定します",
  TXT_NO_HYPHEN: "ハイフンなし",
  TXT_EXPORT_ACTIONS: "このピンの行動データをエクスポートします",
  TXT_EXPORT_CVS:
    "データをエクスポートします。必ず「Search」から期間を60日以内に絞り込んで実行してください。",
  TXT_EXPORT_CVS_FORMAT: "エクスポートファイルのフォーマットを設定します",
  TXT_SHOW_URLS_HISTORY: "このURLの行動履歴を表示します",
  TXT_RECENT_PV: "直近のPV",
  TXT_RECENT_CV: "直近のピン到達数",
  TXT_MONTHLY_CV: "今月のピン到達数",
  TXT_ALL_CV: "全ての期間のピン到達数",
  TXT_CVNUM: "ピン到達数",
  TXT_EVENT_NUM: "イベント登録数",
  TXT_DISPLAY_TO: "を表示中",
  TXT_SHOW_TO: "を表示",
  TXT_SETTEINGS: "の設定",
  TXT_WITHIN_CHAR: "文字以内",
  TXT_USERID_SEARCH_NOTICE: "シンクされたデータも同時に抽出します",
  TXT_URL_FULL: "URLパラメーターを省略",
  TXT_REGISTED_ITEM: "登録済みの",
  TXT_PINS_FROM_DAYS_AGO: "日前までのピン到達",
  TXT_SAME_USER: "同一ユーザーの",
  TXT_TERMINAL_IP: "現在アクセスしている端末のIPアドレスは",
  TXT_EXPIRE_TEST_MODE: "テストモードの有効期限",
  TXT_BEAUTY_CLINIC_SITE: "美容クリニックのサイト",
  TXT_INTEREST_BEAUTY_SKIN: "美肌への関心",
  TXT_CLUSTER_NAME: "クラスタ名",
  TXT_APP_CONDITION: "適用条件",
  TXT_PRIORITY: "優先順",
  TXT_CURRENT_SET: "現行の設定",
  TXT_PAST_SET: "過去の設定",
  TXT_EXPORT_FORMAT: "エクスポートファイルのフォーマット",

  TXT_FLAG_ON: "有り",
  TXT_FLAG_OFF: "無し",
  TXT_DESU: "です。",

  HELP_LINK_URL_RULE_1:
    "リンクのURLルールを設定する事で、'ピンのID'をクリックした時の遷移先をカスタマイズできます。",
  HELP_LINK_URL_RULE_2:
    "リンクのURLルールには、'ピンのID'を挿入する {{id}} の差し込み記号と、「検知したパラメータ」のパラメータ名を{{...}}で囲った差し込み記号が使用できます。",
  HELP_LINK_URL_RULE_3:
    "例えば、 'ピンのID'が'111'で、「検知したパラメータ」にcodeという名前で'0001'の値がセットされている場合は下記の挙動になります。",
  HELP_LINK_URL_RULE_4:
    "[ https://shop.pinn-gu.com/admin/order/{{id}}/{{code}} ] と設定",
  HELP_LINK_URL_RULE_5:
    "'ピンのID'をクリックした時の遷移先は https://shop.pinn-gu.com/admin/order/111/0001",

  HELP_PROJECT_1: "全てのトラッキングデータはプロジェクト単位で保持されます。",
  HELP_PROJECT_2:
    "トラッキングデータを混同させたくない場合、プロジェクトを分割する事でそれぞれデータを管理できます。",

  HELP_DOMAIN_1:
    "入力したドメインとそのサブドメインが利用可能なドメインとなります。",
  HELP_DOMAIN_2: "例) 「*.pinn-gu.com」と登録した場合、",
  HELP_DOMAIN_3:
    "pinn-gu.com、www.pinn-gu.com、shop.pinn-gu.com  など... ←利用可能",
  HELP_DOMAIN_4: "pinn-gu.jp ←利用不可",

  HELP_USER_ID_1:
    "「ユーザーの識別子」に同じ値を挿入したユーザーは同一のユーザーと判定します。",
  HELP_USER_ID_2:
    "例えばメンバーログイン完了後のページにおいて、システムで管理しているメンバーIDを「ユーザーの識別子」に挿入する事で、異なる端末でログインしたユーザーを同一ユーザーとして扱う事ができます。",
  HELP_USER_ID_3:
    '「ユーザーの識別子」を挿入したパラメータタグの例を下記に記します。「ユーザーの識別子」が不明な場合は空文字("")のままとして下さい。',

  HELP_PINS_ID_1:
    "ピン到達の対象ページにて、「ピンの識別子」にトランザクションIDを挿入する事で、ピンの到達データと実際のトランザクションデータを紐付ける事ができます。",
  HELP_PINS_ID_2:
    "例えばお申し込み完了後のページにおいて、お申し込みを特定するIDを「ピンの識別子」に挿入する事でピンの到達とお申込みデータが同一のものと判断できるようになります。",
  HELP_PINS_ID_3:
    '「ピンの識別子」を挿入した例を下記に記します。不明な場合は空文字("")のままとして下さい。',

  HELP_PINS_PARAM_1:
    "ピン到達の対象ページにて、「ピンの付加情報」に任意の情報を渡す事でピンの到達データにより多くの情報を付加できます。",
  HELP_PINS_PARAM_2:
    "例えば商品のご購入完了後のページにおいて、商品名や商品価格、商品個数等を「ピンの付加情報」に挿入する事でピンの到達データに紐付けて付加情報を参照する事ができます。",
  HELP_PINS_PARAM_3:
    "「ピンの付加情報」を挿入した例を下記に記します。不明な場合は空({})のままとして下さい。",
  HELP_PINS_PARAM_4:
    "※商品名が「サプリメントA」、商品価格が「980」、商品個数が「2」の情報を挿入した例です。",
  HELP_PINS_PARAM_5:
    "※計測の不具合を避けるため、jsonのキーは半角英数字で指定してください。",

  HELP_TARGET_ITEM:
    "対象の要素があるページを開き、右クリックのメニュー「ページのソースを表示」やGoogle Chromeの開発者ツール等を使用して、要素の属性値（id、class、name等..）の値をご確認ください。",

  HELP_TEST_MODE:
    "テストモードを起動し、「接続元IPアドレス」で指定したIPアドレスから計測対象のページにアクセスする事で、即座にトラッキングログの参照を行えます。",
  HELP_CLUSTER_PRIORITY:
    "この行をドラッグして優先度を変更できます。上のクラスタほど優先されて適用されます。",
  HELP_CSV_FORMAT_ORDER: "この行をドラッグして出力の順番を変更できます",

  TXT_REGISTED: "が作成されました",
  TXT_DELETED: "が削除されました",
  TXT_UPDATED: "が更新されました",
  TXT_APPLY: "が適用されました",
  TXT_COPY_TO: "をコピーします",
  TXT_COMPLETE_PW_RESET_MAIL: "パスワード再設定に関するメールを送信しました",
  TXT_COMPLETE_PW_RESET: "パスワードが再設定されました",
  TXT_CONFIRM_REGIST: "を作成します。",
  TXT_CONFIRM_UPDATE: "を更新します。",
  TXT_CONFIRM_DELETE: "を削除します。この操作は取り消しできません。",
  TXT_CONFIRM_DELETE_PROJECT_BODY:
    "このプロジェクトの全てのデータは参照できなくなります。",
  TXT_CONFIRM_UPDATE_DOMAIN_BODY:
    "現在までのドメインでのトラッキングが行えなくなる可能性があります。十分に注意して変更してください。",
  TXT_CONFIRM_LIMIT_ADD_TITLE: "プラン上限の変更を申請します",
  TXT_CONFIRM_LIMIT_ADD_BODY:
    "当月に上限の引き下げは行えません。ご注意ください。",
  TXT_PASSWORD_NOTICE: "変更する場合のみ入力してください",
  TXT_ACTIONS_NOTICE_1: "ピン到達以前",
  TXT_ACTIONS_NOTICE_2: "日までの行動を保持しています",
  TXT_IP_NOTICE: "カンマ(,)区切りで複数指定できます。",
  TXT_SHOWTO: "を見る",
  TXT_COMPANY_NAME_NOTICE:
    "会社名と担当者名を省略した場合は、組織の名前と管理者の名前を使用します。",
  TXT_ACTION_PAGE_NOTICE:
    "登録がない場合は、計測タグを貼ったすべてのページが計測対象となります。",
  TXT_BLOCK_PAGE_NOTICE:
    "「除外ページのURL」は「対象ページのURL」より優先され適用されます。",
  TXT_URL_PART_NOTICE:
    "「計測対象ページ」から外れている場合は一致されませんのでご注意ください。",
  TXT_PROJECT_NAME_NOTICE:
    "例）自社ECサイトの行動計測、コーポレートサイトの行動計測 など..",
  TXT_EVENT_NAME_NOTICE_1:
    "何を検知するイベントなのか明確な名前を指定してください。",
  TXT_EVENT_NAME_NOTICE_2:
    "例）バナーAへのスクロール到達、入力フィールドAへの入力 など..",
  TXT_PINN_NAME_NOTICE_1:
    "何を達成したピンなのか明確な名前を指定してください。",
  TXT_PINN_NAME_NOTICE_2: "例）予約お申し込みの完了、メンバー登録完了 など..",
  TXT_EVENT_TARGET_NOTICE_1:
    "動的に追加される要素は取得できない可能性があります。",
  TXT_EVENT_TARGET_NOTICE_2:
    "複数の要素が取得できる場合は先頭の要素が対象となります。",
  TXT_EVENT_PARAM_NOTICE:
    "このイベント形式には、固有の追加設定があります。必ず入力してください。",
  TXT_FORNOW_NOTICE: "後から変更ができます",
  TXT_NONPROJECT_NOTICE_1: "ようこそpinnの管理コンソールへ。",
  TXT_NONPROJECT_NOTICE_2: "プロジェクトを作成",
  TXT_NONPROJECT_NOTICE_3: "してデータの箱を用意しましょう。",
  TXT_CV_LIMIT_OVER_NOTICE:
    "現在トラッキングはストップしています。再開するには、ピン到達数の上限変更を行なってください。",

  TXT_PROJECT_CREATED_NOTICE: "早速トラッキングの設定を行いましょう。",

  TXT_LIMIT_ADD_NOTICE:
    "「現在の設定」より少ない上限に変更する場合は、翌月からの適用となります。",
  TXT_SITE_POSITION_NOTICE_1:
    "計測対象のサイトがどのようなサイトか、一般的に通用する呼称を設定してください。",
  TXT_SITE_POSITION_NOTICE_2:
    "例）美容クリニックのサイト、アパレル販売のサイト など..",
  TXT_RC_ITEMS_SET:
    "更新以降に解析したピンのレーダーチャートが対象となります。",

  TXT_CV_NOT_REGISTED: "ピンは必ず１つ以上設定してください。",

  TXT_TRACKING_TAG_EXPLAIN_1:
    "計測対象とする全てのページを編集し、<body>タグのすぐ下に下記の「計測タグ」を貼り付けて下さい。",
  TXT_TRACKING_TAG_EXPLAIN_2:
    "計測対象のページは「計測対象ページの設定」でさらに詳細の設定が行えます。",

  TXT_TRACKING_SUB_TAG_EXPLAIN_1:
    "ピン到達の対象ページやユーザーを特定できるページでは、<body>タグ内の任意の場所に下記の「パラメータタグ」を貼り付ける事で、付加情報を送る事ができます。",
  TXT_TRACKING_SUB_TAG_EXPLAIN_2:
    "同一ページに「計測タグ」が貼り付けてある必要があります。",
  TXT_TRACKING_SUB_TAG_EXPLAIN_3:
    "「パラメータタグ」は「計測タグ」より上に貼り付けるようにしてください。（GTMなどでは計測タグより前に配信するように設定して下さい。）",
  TXT_ANALYZE_EXPLAIN: "ピンの解析に利用する要素を設定します",
  TXT_ANALYZE_RC_EXPLAIN: "解析結果のレーダーチャートを設定します",
  TXT_USER_ID_HELP: "ユーザーの識別子とは",
  TXT_PINS_ID_HELP: "ピンの識別子とは",
  TXT_PINS_PARAM_HELP: "ピンの付加情報とは",

  TXT_PINSNAME_EX: "お申し込み完了",
  TXT_EVENTSNAME_EX: "バナーAへの到達有無",
  TXT_PROJECTNAME_EX: "自社ECサイトの行動計測",
  TXT_CLUSTERCATNAME_EX: "メルマガ配信区分",
  TXT_CLUSTERNAME_EX: "メルマガ001",

  TXT_PASSRESET_MAIL_NOTICE:
    "パスワード再設定用のURLを送信します。ご登録のメールアドレスを入力してください。",
  TXT_PASSRESET_NOTICE:
    "パスワードを再設定します。新しく設定するパスワードを入力してください。",

  TXT_ANALYZE_SECTION_NOSETTEING:
    "ピンの解析設定が行われていないため、カルテを作成できませんでした。",
  TXT_ANALYZE_SECTION_NOAPP:
    "ピンの解析設定が行われていなかったため、カルテ作成の対象ではありません。",
  TXT_ANALYZE_SECTION_RETRY:
    "ピンの解析中にエラーが発生しました。再度ピンの解析を行っています。",
  TXT_ANALYZE_SECTION_BUSY:
    "ピンの解析に通常より時間がかかっています。カルテ作成まで今しばらくお待ちください。",
  TXT_ANALYZE_SECTION_RUNNING:
    "ピンの解析中です。カルテ作成までは通常3時間程必要です。",
  TXT_NO_ANALYZE_DATA: "解析されたピンのデータがありません",
  TXT_CLUSTER_CATEGORY_NAME_NOTICE:
    "例）DM送付区分、メルマガ配信区分、会員区分 など..",
  TXT_CLUSTER_NAME_NOTICE: "例）DM001、メルマガ001、会員区分A など..",
  TXT_CONDITION_AND_NOTICE: "全てに一致して適用されます",
  TXT_CREATE_DEVELOPPERS_ACCOUNT_NOTICE:
    "開発者アカウントが作成されています。必ず下記の情報をコピーしてからダイアログを閉じてください。",

  ERR_INVALID_OPERATION: "不正な画面遷移です",
  ERR_UNEXPECTED: "予期せぬエラーが発生しました。",
  ERR_UNEXPECTED_BODY: "お手数ですが、しばらくしてから再度実行してください。",
  ERR_SECURITY:
    "時間経過や不正操作によるセキュリティエラーが発生しました。画面を再読み込みしてください。",
  ERR_TOO_MANY_REQ:
    "一定期間に処理できる数の許容値を超えました。数分してから再度実行してください。",
  ERR_SECURITY_BODY:
    "画面を再読み込みするか、ブラウザを再起動してから実行してください。",
  ERR_BROWSER:
    "セキュリティ担保のため、申請時と同一のブラウザで操作を行なってください",
  ERR_REGISTED: "既に登録されています",
  ERR_NORMAL: "エラーが発生しました",
  ERR_NOT_ALLOWED: "このページにはアクセスできません",
  ERR_PAGE_NOTFOUND: "ページが存在しません",

  ERR_LINK: "必ず下記のリンクから画面を再読み込み行なってください。",
  ERR_RELOGIN: "下記からログインを行なってください。",
  ERR_SECURITY_ATTENTION:
    "それでも解消しない場合は、一度ご利用のブラウザを再起動してから実行してください。",

  ERR_CREDIT_CARD: "カード情報をご確認ください。",
  ERR_FILE_EXPIRED: "※ファイルを表示できません",
  ERR_NOT_GET: "※取得できませんでした",
  ERR_BROWSER_MAX_FILE_SIZE:
    "このブラウザでアップロードできるファイルサイズを超えています。",
};

export const SYSTEM_CONST = {
  SELF_URL: "https://admin.pinn-gu.com/",

  CAPCHA_API_URL: "https://s.wordpress.com/mshots/v1/",
  G_RECAPCHA_SITE_KEY: "6Lff7J4qAAAAAFuPe61SxKWPdwA3WqfrP5cP-NeL",
  NOIMAGE_PATH: "/assets/img/noimage.svg",

  SNACKBAR_SECOND_SUCCESS: 3000,
  SNACKBAR_SECOND_ERROR: 2500,
};

export const API_CONNECTION = {
  URL: "https://admin-api.pinn-gu.com/",
};

if (-1 < window.location.href.indexOf("://dev.admin.pinn-gu.com")) {
  API_CONNECTION.URL = "https://dev.admin-api.pinn-gu.com/";
  SYSTEM_CONST.SELF_URL = "https://dev.admin.pinn-gu.com/";
}
if (-1 < window.location.href.indexOf("://localhost")) {
  API_CONNECTION.URL = "http://localhost:8822/";
  SYSTEM_CONST.SELF_URL = "http://localhost:3000/";
}
